document.addEventListener('DOMContentLoaded', () => {
// Nascondi bottoni checkout rapido
const nascondiBotoni = () => {
  const el = document.querySelector('#dynamic-checkout-cart') || 
             document.querySelector('.cart__dynamic-checkout-buttons');
  if (el) el.style.display = 'none';
};
nascondiBotoni();
// Riprova dopo caricamento asincrono dei bottoni
setTimeout(nascondiBotoni, 1000);
setTimeout(nascondiBotoni, 2000);
  // Aggiungi link "Carica la tua tesi" nella notifica carrello
  const osserva = new MutationObserver(() => {
    const links = document.querySelector('.cart-notification__links');
    if (links && !links.querySelector('.cart-notification__carica-tesi')) {
      const continuaShopping = links.querySelector('.link.button-label');
      const link = document.createElement('a');
      link.href = '/pages/carica-la-tua-tesi';
      link.className = 'cart-notification__carica-tesi button button--secondary button--full-width';
      link.style.cssText = 'margin-top:10px;';
      link.textContent = '📄 Carica la tua tesi';
      if (continuaShopping) {
        links.insertBefore(link, continuaShopping);
      } else {
        links.appendChild(link);
      }
    }
  });

  osserva.observe(document.body, { childList: true, subtree: true });

  // Blocca checkout — obbliga a passare dalla pagina carica-tesi
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[name="checkout"], .cart__checkout-button, #checkout, [href="/checkout"], #CartDrawer-Checkout');
    if (!btn) return;

    // Se siamo già sulla pagina carica-tesi e il click viene dal btn-checkout della draft order, lascia passare
    if (btn.classList.contains('btn-checkout-draft')) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    // Controlla se esiste già una draft order URL salvata
    const draftUrl = sessionStorage.getItem('draft_checkout_url');

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const hasPDF = cart.items.some(item =>
          item.properties &&
          item.properties['_num_pagine'] &&
          parseInt(item.properties['_num_pagine']) > 0
        );

        if (!hasPDF || !draftUrl) {
          alert('⚠️ Prima di procedere al pagamento devi caricare il PDF della tua tesi dalla pagina "Carica la tua tesi".');
          window.location.href = '/pages/carica-la-tua-tesi';
        } else {
          window.location.href = draftUrl;
        }
      })
      .catch(() => {
        window.location.href = '/pages/carica-la-tua-tesi';
      });
  }, true);

});